export enum AnalyticsPages {
  TEAMS = 'teams',
  TEAM_DETAIL = 'teamDetail',
}

export const AnalyticsPlaces = {
  LIST: 'TeamsList',
  DETAIL: 'TeamDetail',
}
